<app-navigation></app-navigation>
<mat-card class="card">
  <mat-card-content>
    <form [formGroup]="form" class="form">
      <h1>Login</h1>
      <mat-form-field class="input-section">
        <mat-label>Email</mat-label>
        <input type="email" matInput formControlName="email" placeholder="Ex. pat@example.com" autocomplete="email" />
        @if (form.controls.email.hasError('email') && !form.controls.email.hasError('required')) {
          <mat-error>Please enter a valid email address</mat-error>
        }
        @if (form.controls.email.hasError('required')) {
          <mat-error>Email is <strong>required</strong></mat-error>
        }
      </mat-form-field>
      <mat-form-field class="input-section">
        <mat-label>Password</mat-label>
        <input type="password" matInput formControlName="password" autocomplete="current-password" />
        @if (!form.controls.password.hasError('required')) {
          <mat-error>Please enter a password</mat-error>
        }
        @if (form.controls.password.hasError('required')) {
          <mat-error>Password is <strong>required</strong></mat-error>
        }
      </mat-form-field>
      @if ($authError() !== '') {
        <mat-error>{{ $authError() }}</mat-error>
        <br />
      }
      <button type="button" routerLink="../resetpassword" mat-button>Passwort vergessen?</button>

      <div class="buttons">
        @if (showRegister) {
          <button routerLink="../register" mat-button>zur Registrierung</button>
        }

        <button type="submit" mat-flat-button color="primary" (click)="onLogin()">Login</button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
